// extracted by mini-css-extract-plugin
export var blogLogoTagline = "bloglogotagline-module--blogLogoTagline--c1417";
export var dark = "bloglogotagline-module--dark--ecfe7";
export var formattedTagline = "bloglogotagline-module--formattedTagline--33b44";
export var light = "bloglogotagline-module--light--a74ce";
export var logo = "bloglogotagline-module--logo--76066";
export var styledGrid = "bloglogotagline-module--styledGrid--fd283";
export var title = "bloglogotagline-module--title--89c07";